import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'
import FrontPageEnum from '../enumerators/front-page.enum'

export default class SliderHomeComponent {
    constructor() {
        this.swipers = []

        this.strateInspirations()
        this.strateAgenda()
    }

    strateInspirations() {
        if (
            $(FrontPageEnum.CONTAINER_INSPIRATIONS).length > 0 &&
            !$(FrontPageEnum.CONTAINER_INSPIRATIONS).is(':hidden')
        ) {
            const swiperContentKey = 'strateInspirations-content-swiper'

            const options = {
                allowTouchMove: true,
                keyboard: true,
                loop: true,
                slidesPerView: 'auto',
                initialSlide: 2,
                spaceBetween: 15,
                pagination: {
                    el: "[data-pagination='strate-inspirations-progressbar']",
                    type: 'progressbar',
                },
                speed: 10000,
                autoplay: {
                    delay: 0,
                    pauseOnMouseEnter: true,
                },
                breakpoints: {
                    650: {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                    },
                    999: {
                        slidesPerView: 'auto',
                        spaceBetween: 35,
                        pagination: false,
                        autoplay: true,
                    },
                },
            }

            this.initSwiper(swiperContentKey, 'strate-inspirations__item', options)
        }
    }

    strateAgenda() {
        if (
            $(FrontPageEnum.CONTAINER_AGENDA).length > 0 &&
            !$(FrontPageEnum.CONTAINER_AGENDA).is(':hidden')
        ) {
            const swiperContentKey = 'strateAgenda-swiper'

            const options = {
                allowTouchMove: true,
                keyboard: true,
                slidesPerView: 1.15,
                spaceBetween: 15,
                pagination: {
                    el: "[data-pagination='strate-agenda-progressbar']",
                    type: 'progressbar',
                },
                breakpoints: {
                    650: {
                        slidesPerView: 1.5,
                        spaceBetween: 20,
                    },
                    999: {
                        slidesPerView: 1.5,
                        spaceBetween: 40,
                        pagination: false,
                    },
                },
            }
            this.initSwiper(swiperContentKey, 'strate-agenda__item', options)
        }
    }

    async initSwiper(swiperKey, slideItemClass, options) {
        const slideItem = `[data-swiper="${swiperKey}"] > .${slideItemClass}`
        $(slideItem).wrapAll('<div class="swiper-wrapper"></div>').addClass('swiper-slide')
        this.swipers[swiperKey] = await Swiper.create(`[data-swiper="${swiperKey}"]`, options)
    }
}
